import React, { useState, useEffect, useRef } from "react";
import {
  TableWrapperDesktop,
  THead,
  THeadTR,
  TH,
  TableHeadText,
  TBody,
  TBodyTR,
  TableWrapperMobile,
  TD,
  TableBodyText,
  BodyWrapper,
  BodyRowWrapper,
  TDFirst,
  StatusTD,
  QRCodeTD,
  DeleteBox,
  DeleteText,
  DeleteButton,
  IconTD,
  TableBodyTextII,
} from "./Table.styles";
import { paymentLinkTableHeaderMobile } from "./TableData";
import _ from "lodash";
import { LuCalendarDays } from "react-icons/lu";
import { MdDelete } from "react-icons/md";
import { CopyIcon, ScanBarcode, ThreeDots } from "../../../../public/assets";
import Pagination from "../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { DELETE_TRANSACTION } from "../../../graphql/mutations/transaction";

interface TableProps {
  headData: { label: string; cellWidth: string }[];
  bodyData?: {
    id: string;
    createdAt: string;
    productName: string;
    amount: string;
    status: string;
    qRCode?: string;
    shortcode?: string;
    button1?: string;
    button2?: string;
    transactionId?: string;
    type?: string;
  }[];
  status: string;
  map?: (value?: any) => any;
}

const Table: React.FC<TableProps> = ({ headData, bodyData, status, map }) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showDeleteBox, setShowDeleteBox] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [transactions, setTransactions] = useState(bodyData);
  const recordsPerPage = 4;
  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = startIndex + recordsPerPage;
  // const displayedRecords = bodyData ? bodyData.slice(startIndex, endIndex) : [];
  const displayedRecords = transactions
    ? transactions.slice(startIndex, endIndex)
    : [];

  const navigate = useNavigate();
  const deleteBoxRef = useRef<HTMLDivElement>(null);
  const [deleteTransactionMutation] = useMutation(DELETE_TRANSACTION, {
    variables: {
      deleteTransactionId: null,
    },
  });
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        deleteBoxRef.current &&
        !deleteBoxRef.current.contains(event.target as Node)
      ) {
        setShowDeleteBox(false);
      }
    };
    if (showDeleteBox) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDeleteBox]);

  useEffect(() => {
    setTransactions(bodyData);
  }, [bodyData]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const getStatusColor = (status: any) => {
    switch (status) {
      case "pending":
        return "orange";
      case "success":
        return "green";
      case "failed":
        return "red";
      default:
        return "black";
    }
  };
  const getBackgroundColor = (status: string) => {
    switch (status) {
      case "pending":
        return "#E89D2B1A";
      case "success":
        return "#4BB5431A";
      case "failed":
        return "#FA3E3E1A";
      default:
        return "transparent";
    }
  };
  const handleTableId = (id: string) => {
    navigate(`/dashboard/transaction-by-id/${id}`);
    console.log("id", id);
  };

  const handleDelete = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    console.log("Delete item with ID:", selectedId);

    try {
      const { data } = await deleteTransactionMutation({
        variables: { deleteTransactionId: selectedId },
      });
      console.log("Mutation response:", data.deleteTransaction.message);
      setTransactions((prevTransactions) => {
        if (!prevTransactions) return prevTransactions;
        return prevTransactions.filter(
          (transaction) => transaction.id !== selectedId
        );
      });
      setShowDeleteBox(false);
    } catch (error) {
      console.error("Error deleting transaction:", error);
    }
  };

  return (
    <>
      <TableWrapperDesktop>
        <THeadTR>
          {headData.map((headerData, index) => (
            <TH key={index}>
              <TableHeadText>{headerData.label}</TableHeadText>
            </TH>
          ))}
        </THeadTR>

        {displayedRecords.length > 0 &&
          displayedRecords.map((tableBody, index) => (
            <TBodyTR
              // onClick={
              //   status === "transaction"
              //     ? () => handleTableId(tableBody.id)
              //     : undefined
              // }
              even={index % 2 === 0}
              key={index}
            >
              <TDFirst>
                <LuCalendarDays size={"20px"} color={"#7A8699"} />

                <TableBodyText>
                  {new Date(parseInt(tableBody?.createdAt)).toLocaleString(
                    "en-US",
                    {
                      month: "long",
                      day: "2-digit",
                      year: "numeric",
                    }
                  )}
                  <span
                    style={{
                      fontFamily: "GT Walsheim Pro",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "20px",
                      letterSpacing: "0.02em",
                      color: "#868686",
                      marginLeft: "10px",
                      paddingTop: "8px",
                    }}
                  >
                    {new Date(parseInt(tableBody?.createdAt)).toLocaleString(
                      "en-US",
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      }
                    )}
                  </span>
                </TableBodyText>
              </TDFirst>
              {map?.(tableBody) || null}
              {tableBody.productName && (
                <TD>
                  <TableBodyText>{tableBody.productName}</TableBodyText>
                </TD>
              )}
              {tableBody.amount && (
                <TD>
                  <TableBodyText>{tableBody.amount}</TableBodyText>
                </TD>
              )}
              {status === "transaction" && !map ? (
                <>
                  <TD>
                    <TableBodyTextII>{tableBody.type}</TableBodyTextII>
                  </TD>

                  <QRCodeTD>{tableBody.id.substring(0, 18) + ""}</QRCodeTD>

                  <StatusTD>
                    <button
                      style={{
                        border: `1px solid ${getStatusColor(tableBody.status)}`,
                        padding: "5px",
                        width: "70%",
                        borderRadius: "15px",
                        color: getStatusColor(tableBody.status),
                        backgroundColor: getBackgroundColor(tableBody.status),
                      }}
                    >
                      {tableBody.status}
                    </button>
                  </StatusTD>
                  {/* <IconTD>
                    <img src="/assets/svg/icon.svg" alt="" />
                  </IconTD> */}
                </>
              ) : null}
            </TBodyTR>
          ))}
        <></>
      </TableWrapperDesktop>
      <Pagination
        totalPages={Math.ceil((bodyData?.length ?? 0) / recordsPerPage)}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
      <TableWrapperMobile>
        <THead>
          <THeadTR>
            {paymentLinkTableHeaderMobile.map((headerData, index) => (
              <TH cellWidth={headerData.cellWidth} key={index}>
                <TableHeadText>{headerData.label}</TableHeadText>
              </TH>
            ))}
          </THeadTR>
        </THead>

        {/* <TBody>
            <TBodyTR even={false}>
            <EmptyDashboard/>
            </TBodyTR>
          </TBody> */}
        {/* <EmptyDashBoard /> */}
      </TableWrapperMobile>
    </>
  );
};

export default Table;
